// Diretor da trilha: decide qual faixa toca e com que crossfade. Não toca nada
// sozinho: recebe um MusicPlayer (no navegador, elementos <audio> com ganho no
// Web Audio; nos testes, um falso que só anota a linha do tempo).
import type { GameEvent } from '@estandarte/engine';
import type { MusicTrack } from './samples';

export interface MusicPlayer {
  /** Troca para a faixa (ou silêncio, com null) em `fade` segundos. */
  crossfade(to: MusicTrack | null, fade: number): void;
}

export const FADE = {
  /** Menu → partida e volta. */
  scene: 1.5,
  bossIn: 2,
  bossOut: 3,
  end: 2,
  /** Crossfade do próprio loop, para faixas que não fecham limpo. */
  loop: 2,
} as const;

export type Scene = 'menu' | 'game' | 'over';

export class MusicDirector {
  private scene: Scene | null = null;
  private boss = false;
  current: MusicTrack | null = null;

  constructor(private player: MusicPlayer) {}

  private go(to: MusicTrack | null, fade: number) {
    if (to === this.current) return;
    this.current = to;
    this.player.crossfade(to, fade);
  }

  /** Menu/sala de espera, partida em andamento ou partida encerrada. */
  setScene(scene: Scene, hasBoss = false): void {
    if (scene === this.scene && (scene !== 'game' || hasBoss === this.boss)) return;
    this.scene = scene;
    this.boss = hasBoss;
    if (scene === 'menu') this.go('menu', FADE.scene);
    else if (scene === 'over') this.go(null, FADE.end);
    else this.go(hasBoss ? 'boss' : 'battle', FADE.scene);
  }

  /** Reage aos eventos de uma ação da partida. */
  onEvents(events: GameEvent[]): void {
    for (const e of events) {
      if (e.type === 'gameOver') {
        this.scene = 'over';
        this.go(null, FADE.end);
        return;
      }
      if (this.scene !== 'game') continue;
      if (e.type === 'bossSpawn') {
        this.boss = true;
        this.go('boss', FADE.bossIn);
      } else if (e.type === 'bossKilled' || e.type === 'bossRaid') {
        this.boss = false;
        this.go('battle', FADE.bossOut);
      }
    }
  }
}
